

















import axios from 'axios';
import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapMutations } from 'vuex';
import { getModule } from 'vuex-module-decorators';

import { IApiResponseLogin } from '@/interfaces';
import AdminCredentialModule from '@/store/modules/AdminCredentialModule';

const adminCredentialModule = getModule(AdminCredentialModule);

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    loginName: { required },
    password: { required },
  },
  data() {
    return {
      loginName: '',
      password: '',
      loading: false,
      formValid: true,
      submitError: '',
    };
  },
  computed: {
    loginNameErrors() {
      const errors: string[] = [];
      if (!(this.$v.loginName as any).$dirty) { return errors; }
      if (!(this.$v.loginName as any).required) {
        errors.push('入力してください');
      }

      return errors;
    },
    passwordErrors() {
      const errors: string[] = [];
      if (!(this.$v.password as any).$dirty) { return errors; }
      if (!(this.$v.password as any).required) {
        errors.push('入力してください');
      }

      return errors;
    },
  },
  methods: {
    formSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      this.submitError = '';
      adminCredentialModule.apiAdminLogin({ loginname: this.$data.loginName, password: this.$data.password })
        .then((response: IApiResponseLogin) => {
          this.loading = false;
          if (response.success === false) {
            this.submitError = response.error.message;
            return;
          }

          this.$router.push('/');
        }).catch((error) => {
          this.loading = false;
        });
    },
  },
});
